import { render } from "./MoreResult.vue?vue&type=template&id=0fbf91f0&scoped=true"
import script from "./MoreResult.vue?vue&type=script&lang=js"
export * from "./MoreResult.vue?vue&type=script&lang=js"

import "./MoreResult.vue?vue&type=style&index=0&id=0fbf91f0&lang=scss&scoped=true"

import exportComponent from "/Users/andyhsieh/Desktop/tourist-site-project-master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbf91f0"]])

export default __exports__